import React, { Component } from 'react';
import {
  Input,
  FormGroup,
  Label,
} from 'reactstrap';
import { SketchPicker } from 'react-color';
import styled from 'styled-components';
import PropTypes from 'prop-types';

export default class ColorInput extends Component {
  constructor(props) {
    super(props);
    this.toggleShow = this.toggleShow.bind(this);
    this.colorChange = this.colorChange.bind(this);
    const { color } = this.props;
    this.state = {
      color,
      show: false,
    };
  }

  handleClose = () => {
    this.setState({ show: false });
  };

  toggleShow() {
    const { show } = this.state;
    this.setState({
      show: !show,
    });
  }

  colorChange(color) {
    const { onChange } = this.props;
    const { name } = this.props;
    this.setState({
      color: `rgba(${color.rgb.r}, ${color.rgb.g}, ${color.rgb.b}, ${color.rgb.a})`,
    });
    onChange(`rgba(${color.rgb.r}, ${color.rgb.g}, ${color.rgb.b}, ${color.rgb.a})`, name);
  }

  render() {
    const {
      name, id, placeholder, label, value,
    } = this.props;
    const { color, show } = this.state;
    return (
      <div>
        <FormGroup>
          <Label for="name">{label}</Label>
          <InputStyled
            type="text"
            name={name}
            id={id}
            placeholder={placeholder}
            value={color || value}
            bgcolor={color || value}
            onChange={() => console.log('...')}
            onClick={this.toggleShow}
          />
          {
            show ? (
              <Popover>
                <Cover onClick={this.handleClose} />
                <Picker
                  color={color}
                  onChange={this.colorChange}
                />
              </Popover>
            ) : ''
          }
        </FormGroup>
      </div>
    );
  }
}
ColorInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

const Picker = styled(SketchPicker)`
  position: absolute;
`;
const InputStyled = styled(Input)`
  background-color: ${(props) => props.bgcolor} !important;
  margin-bottom: 10px;
`;

const Popover = styled.div`
  position: relative;
  z-index: 2;
`;
const Cover = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;
